import {contactApiHostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const create = async (group) => {
  try {
    const result = await fetch(`${contactApiHostName}/group`, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(group),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
